import { useEffect, useState } from 'react'

import { PLATFORM } from '../../utils/enums'
import useWhereAmIRunning from '../whereAmIRunning'

function hostnameMatches(hostname: string, domain: string): boolean {
  return hostname === domain || hostname.endsWith(`.${domain}`)
}

export function getPlatformFromUrlString(
  urlString: string | undefined,
): PLATFORM | null {
  if (!urlString) {
    return null
  }
  let hostname: string
  try {
    hostname = new URL(urlString).hostname
  } catch {
    return null
  }
  if (hostnameMatches(hostname, 'bsky.app')) {
    return PLATFORM.BLUESKY
  } else if (hostnameMatches(hostname, 'facebook.com')) {
    return PLATFORM.FACEBOOK
  } else if (hostnameMatches(hostname, 'google.com')) {
    return PLATFORM.GOOGLE
  } else if (hostnameMatches(hostname, 'instagram.com')) {
    return PLATFORM.INSTAGRAM
  } else if (hostnameMatches(hostname, 'linkedin.com')) {
    return PLATFORM.LINKEDIN
  } else if (hostnameMatches(hostname, 'reddit.com')) {
    return PLATFORM.REDDIT
  } else if (hostnameMatches(hostname, 'strava.com')) {
    return PLATFORM.STRAVA
  } else if (
    hostnameMatches(hostname, 'twitter.com') ||
    hostnameMatches(hostname, 'x.com')
  ) {
    return PLATFORM.TWITTER
  } else if (hostnameMatches(hostname, 'venmo.com')) {
    return PLATFORM.VENMO
  } else if (hostnameMatches(hostname, 'youtube.com')) {
    return PLATFORM.YOUTUBE
  } else if (hostnameMatches(hostname, 'tiktok.com')) {
    return PLATFORM.TIKTOK
  }
  return null
}

export function usePlatform(): PLATFORM | null | undefined {
  const { currentTab } = useWhereAmIRunning()
  const [platform, setPlatform] = useState<PLATFORM | null | undefined>()

  const url = currentTab?.url
  useEffect(() => {
    setPlatform(url ? getPlatformFromUrlString(url) : undefined)
  }, [url])

  return platform
}
